import _ from 'lodash';
import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Link, useHistory, useParams } from 'react-router-dom';
import { Typography } from '@mui/material';
import PublicComponentWrapper from '../../wrappers/PublicComponentWrapper';
import { checkSignupEmailToken } from '../../../api/SignupService';
import { submitJoinExistingAccount } from '../../../users/UserActions';
import SignupEmailExisting from './SignupEmailExisting';
import SignupEmailNew from './SignupEmailNew';

const handleErrorMessage = (status: any) => {
  if (status === 400 || status === 404) {
    return (
      <div>
        <Typography variant="body1" align="center" color="error">
          Link Expired/Not Found!
        </Typography>
        <div>
          <Typography variant="body1" color="inherit" align="center">
            To get a new link , please contact Cowbell Support Team.
            <br />
            If you already have an account? <Link to="/login">Login here</Link>
          </Typography>
        </div>
      </div>
    );
  }

  return (
    <div>
      <Typography variant="body1" align="center">
        Opps! {'\n'} Looks like your credentials have expired. <br />
        Contact your account admin to get a new link.
      </Typography>
      <div className="main-entry-signuplanding-error-link">
        <Typography variant="body1" color="inherit" align="center">
          If not an existing user,
          <Link to="/signup" style={{ color: 'inherit' }}>
            {' '}
            signup here
          </Link>
        </Typography>
      </div>
    </div>
  );
};

function SignupEmailLanding() {
  const params = useParams<{ token?: string }>();
  const history = useHistory();
  const dispatch = useDispatch();
  const [data, setData] = useState<any>(undefined);
  const [badToken, setBadToken] = useState(false);
  const [errorStatus, setErrorStatus] = useState<any>(null);

  const boundSubmitJoinExistingAccount = useCallback(
    (payload: any, token: any) =>
      dispatch(submitJoinExistingAccount(payload, token) as any),
    [dispatch]
  );

  useEffect(() => {
    checkSignupEmailToken(params.token)
      .then((resp: any) => setData(resp.data))
      .catch((error: any) => {
        if (error?.response?.status) {
          setBadToken(true);
          setErrorStatus(error.response.status);
        }
      });
    // Mount-once token check.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const tokenType = _.get(data, 'tokenType', undefined);
  const redirectUrl = _.get(data, 'redirectURL');

  useEffect(() => {
    if (tokenType === 'EXISTING_USER') {
      history.push({ pathname: '/login', state: { existingUser: true } });
    } else if (tokenType === 'QUOTE_SENT_EXISTING_USER') {
      history.push({
        pathname: '/login',
        state: { existingUserForQuote: true, redirectUrl },
      });
    } else if (tokenType === 'QUOTE_LINK_EXISTING_AGENT') {
      history.push({
        pathname: '/login',
        state: { existingAgentForQuote: true, redirectUrl },
      });
    }
  }, [tokenType, redirectUrl, history]);

  return (
    <PublicComponentWrapper>
      {badToken && errorStatus && <div>{handleErrorMessage(errorStatus)}</div>}
      {tokenType === 'NEW_ACCOUNT' && (
        <SignupEmailNew
          token={params.token}
          accountType={data.accountType}
          history={history}
        />
      )}
      {tokenType === 'EXISTING_ACCOUNT' && (
        <SignupEmailExisting
          token={params.token}
          data={data}
          submitJoinExistingAccount={boundSubmitJoinExistingAccount}
        />
      )}
      {tokenType === 'QUOTE_SENT_NEW_USER' && (
        <SignupEmailExisting
          token={params.token}
          data={data}
          submitJoinExistingAccount={boundSubmitJoinExistingAccount}
          redirectUrl={redirectUrl}
        />
      )}
      {tokenType === 'QUOTE_LINK_NEW_AGENT' && (
        <SignupEmailExisting
          token={params.token}
          data={data}
          submitJoinExistingAccount={boundSubmitJoinExistingAccount}
          redirectUrl={_.isUndefined(redirectUrl) ? null : redirectUrl}
        />
      )}
    </PublicComponentWrapper>
  );
}

export default SignupEmailLanding;
